import classNames from 'classnames';
import CheckBadge from 'components/atoms/SVG/CheckBadge';
import { motion } from 'motion/react';
import type { FC } from 'react';
import ConfettiBurst from './ConfettiBurst';

const SuccessFeedbackWithConfettiBurst: FC<{
  containerClassName?: string;
  message: string;
}> = ({ containerClassName, message }) => (
  <div
    className={classNames(
      'absolute top-0 right-0 bottom-0 left-0 z-50 bg-white flex flex-col items-center justify-center',
      containerClassName,
    )}
  >
    <motion.div
      {...{
        initial: { scale: 0.4, opacity: 0 },
        animate: {
          scale: 1,
          opacity: 1,
          transition: { duration: 0.6 },
        },
      }}
    >
      <div className="rounded-full h-24 w-24 bg-taxes-200 flex items-center justify-center">
        <CheckBadge />
      </div>
    </motion.div>

    <motion.div
      className="overflow-hidden text-center mt-5"
      {...{
        initial: { translateY: 25, opacity: 0 },
        animate: {
          translateY: 0,
          opacity: 1,
          transition: { delay: 0.6, duration: 0.6 },
        },
      }}
    >
      <div className="text-lg font-semibold max-w-[80%] mx-auto">{message}</div>
    </motion.div>

    <div className="absolute">
      <ConfettiBurst />
    </div>
  </div>
);

export default SuccessFeedbackWithConfettiBurst;
